export default __webpack_public_path__ + "static/media/icon_collect_status_completed.2fbfccc8.png";